<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">การอนุมัติการลา</h2>
    </div>
    <v-card outlined class="pa-4" style="min-height: 576px">
      <v-form ref="form" lazy-validation>
        <div>
          <v-container>
            <h3 class="body-1">ผู้อนุมัติลา</h3>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  :input-value="
                    leaveApproval.normal.priority_order.length ===
                    approverKeys.length
                  "
                  :indeterminate="
                    leaveApproval.normal.priority_order.length > 0 &&
                    leaveApproval.normal.priority_order.length <
                      approverKeys.length
                  "
                  dense
                  label="ทั้งหมด"
                  hide-details
                  @change="handleCheckAll"
                ></v-checkbox>
                <v-divider class="my-2"></v-divider>
                <v-checkbox
                  v-model="leaveApproval.normal.priority_order"
                  dense
                  label="หัวหน้าหน่วยงาน"
                  value="boss"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="leaveApproval.normal.priority_order"
                  dense
                  label="ผู้อนุมัติคนที่ 1"
                  value="leave_approver_1"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="leaveApproval.normal.priority_order"
                  dense
                  label="ผู้อนุมัติคนที่ 2"
                  value="leave_approver_2"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="leaveApproval.normal.priority_order"
                  dense
                  label="ผู้อนุมัติคนที่ 3"
                  value="leave_approver_3"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
          <v-divider class="my-4"></v-divider>
          <v-container>
            <v-row>
              <v-col cols="8">
                <h3 class="body-1">ลำดับผู้อนุมัติ</h3>
                <v-data-table
                  :items="items"
                  :headers="headers"
                  hide-default-footer
                >
                  <template v-slot:item.order="{ item }">
                    {{ item.order }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      icon
                      @click="moveUpKey(item.key)"
                      :disabled="item.index === 0"
                    >
                      <v-icon small>mdi-chevron-up</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      icon
                      @click="moveDownKey(item.key)"
                      :disabled="item.index === items.length - 1"
                    >
                      <v-icon small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-form>
    </v-card>
    <div class="mt-4">
      <v-btn
        color="primary"
        :disabled="
          !isConfigLeaveApprovalChanged ||
          (uiCtrl &&
            !uiCtrl.isEnable('btn:::company_config:leave_approval:update'))
        "
        @click="onSave"
      >
        บันทึก</v-btn
      >
      <v-btn class="ml-2" @click="onCancel">ยกเลิก</v-btn>
    </div>

    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import {
  LEAVE_APPROVER_KEYS,
  LEAVE_APPROVER_LABELS,
} from '@/constants/leaveApproval'
import _ from 'lodash'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'LeaveApproval',
  components: {
    ConfirmDialog,
  },
  data: () => ({
    approverKeys: LEAVE_APPROVER_KEYS,
    approverLabels: LEAVE_APPROVER_LABELS,
    headers: [
      { text: 'ลำดับ', value: 'order', width: 70, sortable: false },
      { text: 'ผู้อนุมัติลา', value: 'label', sortable: false },
      { text: '', value: 'actions', sortable: false, align: 'right' },
    ],
    dialogForbidden: false,
    confirmDialogDataChange: false,
    confirmDialogDataChangeLoading: false,
    confirmDialogDataChangeData: {},
    leaveApproval: {
      normal: {
        priority_order: [],
      },
    },
    leaveApprovalInit: {
      normal: {
        priority_order: [],
      },
    },
  }),
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isConfigLeaveApprovalChanged() {
      return !_.isEqual(this.leaveApproval, this.leaveApprovalInit)
    },
    items() {
      return this.leaveApproval.normal.priority_order.map((k, i) => ({
        key: k,
        label: this.approverLabels[k] || k,
        order: i + 1,
        index: i,
      }))
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การอนุมัติการลา',
        disabled: true,
      },
    ])

    try {
      this.$store.commit('SET_LOADING', true)

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }

      const data = await this.fetchConfigLeaveApproval(payload)

      this.leaveApproval = JSON.parse(JSON.stringify(data))
      this.leaveApprovalInit = JSON.parse(JSON.stringify(data))
    } catch (error) {
      if (error.response && error.response.status === 403) {
        this.dialogForbidden = true
      } else {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    } finally {
      this.$store.commit('SET_LOADING', true)
    }
  },
  methods: {
    ...mapActions({
      fetchConfigLeaveApproval: 'leaveApproval/fetchConfigLeaveApproval',
      updateConfigLeaveApproval: 'leaveApproval/updateConfigLeaveApproval',
    }),
    handleCheckAll(value) {
      if (value) {
        this.leaveApproval.normal.priority_order = [...LEAVE_APPROVER_KEYS]
      } else {
        this.leaveApproval.normal.priority_order = []
      }
    },
    _move(arr, fromIdx, toIdx) {
      if (fromIdx === toIdx) return
      const item = arr.splice(fromIdx, 1)[0]
      arr.splice(toIdx, 0, item)
    },
    moveUpKey(key) {
      const arr = this.leaveApproval.normal.priority_order
      const idx = arr.indexOf(key)
      if (idx > 0) this._move(arr, idx, idx - 1)
    },
    moveDownKey(key) {
      const arr = this.leaveApproval.normal.priority_order
      const idx = arr.indexOf(key)
      if (idx !== -1 && idx < arr.length - 1) this._move(arr, idx, idx + 1)
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      this.confirmDialogDataChange = false
      this.nextRoute(item.data)
    },
    nextRoute(next) {
      next()
    },
    onCancel() {
      this.leaveApproval = JSON.parse(JSON.stringify(this.leaveApprovalInit))
    },
    async onSave() {
      try {
        this.$store.commit('SET_LOADING', true)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          data: {
            normal: {
              allowed_approvers: {
                boss: this.leaveApproval.normal.priority_order.includes('boss'),
                leave_approver_1:
                  this.leaveApproval.normal.priority_order.includes(
                    'leave_approver_1'
                  ),
                leave_approver_2:
                  this.leaveApproval.normal.priority_order.includes(
                    'leave_approver_2'
                  ),
                leave_approver_3:
                  this.leaveApproval.normal.priority_order.includes(
                    'leave_approver_3'
                  ),
              },
              priority_order: this.leaveApproval.normal.priority_order,
            },
          },
        }

        await this.updateConfigLeaveApproval(payload)

        this.leaveApprovalInit = JSON.parse(JSON.stringify(this.leaveApproval))

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'แก้ไขข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', true)
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isConfigLeaveApprovalChanged) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการปิดใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      next()
    }
  },
}
</script>
